import styled from 'styled-components';

const EmptyPanel = styled.div`
  flex-grow: 1;
`;

export const Styled = {
  EmptyPanel,
};
